import React, {Fragment} from "react";
import MatchAndEventMatchReportCard from "./MatchAndEventMatchReportCard";
import classNames from 'classnames';
import Divider from "../../../ui/Divider";
import {Image} from "react-bootstrap";

import '../../../../assets/sass/pages/match-and-event-match-report/match-stats-card.scss';
import ShadowScrollbars from "../../../ui/custom_scrollbars/ShadowScrollbars";

class MatchStats extends MatchAndEventMatchReportCard {
    /**
     * Renders the header of the card component.
     * @returns {React.ReactNode} The card header component.
     */
    renderHeader = () => "Match Stats";

    /**
     * Renders the body of the card component.
     * @returns {React.ReactNode} The card body component.
     */
    renderBody = () => {
        return (
            <Fragment>
                {this.renderTeams()}
                {this.renderStatistics()}
            </Fragment>
        );
    };

    renderTeams = () => {
        const {team1, team2} = this.props;
        return <MatchStats.Teams team1={team1} team2={team2}/>;
    };

    renderStatistics = () => {
        const {team1, team2} = this.props;
        return <MatchStats.Statistics team1={team1} team2={team2}/>;
    };


    /**
     * Wraps the content within scrollbar.
     * @param content {React.ReactNode} The content witch renders within scrollbar.
     * @returns {React.ReactNode} The wrapped component.
     */
    wrapWithinScrollbar = (content) => ShadowScrollbars.wrap(content);

    /**
     * Returns the classes of the card component.
     * @returns {string} The card classes.
     */
    cardClasses = () => classNames('match-and-event-match-report-card', 'match-stats-card');
}

MatchStats.Teams = props => {
    const {team1, team2} = props;
    const {logo: team1Logo} = team1;
    const {logo: team2Logo} = team2;

    return (
        <div className="teams">
            <div className="team left">
                <Image className="team--logo" src={team1Logo}/>
            </div>
            <div className="team right">
                <Image className="team--logo" src={team2Logo}/>
            </div>
        </div>
    );
};

MatchStats.Statistics = props => {
    const {team1, team2} = props;
    const {stats: team1Stats} = team1;
    const {stats: team2Stats} = team2;

    const statistics = [
        {label: 'Fouls', key: 'fouls'},
        {label: 'Yellow Cards', key: 'yellowCard'},
        {label: 'Red Cards', key: 'redCard'},
        {label: 'Offsides', key: 'offsides'},
        {label: 'Corner kicks', key: 'cornerKicks'},
        {label: 'Saves', key: 'saves'},
    ];

    console.log(props);
    // return "E";
    return (
        <div className="match-statistics">
            {statistics.map((item, index) => (
                <Fragment>
                    <div className="match-statistics--item">
                        <div className="value"> {team1Stats[item.key]} </div>
                        <div className="title"> {item.label} </div>
                        <div className="value"> {team2Stats[item.key]} </div>
                    </div>
                    {<Divider show={index !== statistics.length - 1}/>}
                </Fragment>
            ))}
        </div>
    );
};
export default MatchStats;
